// removed by extract-text-webpack-plugin
module.exports = {"NavItems":"NavItems__NavItems__fYdh5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavigationItems/NavItems/NavItems.css
// module id = 47
// module chunks = 0